// 服务器node版本14.21.3，使用echarts5.4打包会报错，先降级到4.9，待后期运维将node放到容器中升级后再换成5X版本
 import echarts from 'echarts/lib/echarts'// 再引入你需要使用的图表类型，标题，提示信息等
 import 'echarts/lib/chart/bar'
 import 'echarts/lib/chart/line'
 import 'echarts/lib/component/legend'
 import 'echarts/lib/component/title'
 import 'echarts/lib/component/toolbox'
 import 'echarts/lib/component/tooltip'
 export default echarts